import { CONSTANTS } from 'config/constants';
import { isSignedInVar, userIdVar } from 'apollo/reactive-vars';
import Cookies from 'js-cookie';
import { DOWNLOAD_WORKSHEET_STORAGE_KEY } from 'components/orders/order-details/use-received-by-lab-worksheet';

const { LAB_ID_KEY, AUTH_FRONTEND_URL, COOKIE_OPTIONS, TOKEN_KEY } = CONSTANTS;

export const logout = (forced: boolean, reason?: string): void => {
    isSignedInVar(false);
    userIdVar('');
    const labId = Cookies.get(LAB_ID_KEY);
    const accordionStates = JSON.parse(localStorage.getItem('accordionStates') || '{}');
    const downloadWorksheetChoice = localStorage.getItem(DOWNLOAD_WORKSHEET_STORAGE_KEY);
    localStorage.clear();
    localStorage.setItem('accordionStates', JSON.stringify(accordionStates));
    if (downloadWorksheetChoice !== null) {
        localStorage.setItem(DOWNLOAD_WORKSHEET_STORAGE_KEY, downloadWorksheetChoice);
    }

    Cookies.remove(TOKEN_KEY, COOKIE_OPTIONS as Cookies.CookieAttributes);
    Cookies.remove(LAB_ID_KEY, COOKIE_OPTIONS as Cookies.CookieAttributes);

    let logoutUrl = `${AUTH_FRONTEND_URL}/login`;
    if (forced) {
        logoutUrl += `?autoLogout=true&returnToUrl=${encodeURIComponent(window.location.href)}`;
        if (reason) {
            logoutUrl += `&reason=${encodeURIComponent(reason)}`;
        }
    }
    if (labId) {
        logoutUrl = `${AUTH_FRONTEND_URL}/login?labId=${labId}`;
    }
    window.location.assign(logoutUrl);
};

// DD-3577: a white-labeled clinic refuses requests that do not come through its lab's
// own site. That refusal also starts with "Access denied", so it must be told apart
// first, or the user is told their session expired and sent round in circles.
const WHITE_LABEL_LOGIN_REQUIRED = 'currentLabId is required for white-labeled clinics';

/**
 * Signs the user out if a request failed because the session can no longer be used,
 * with a reason the login page can explain. Returns whether it did.
 */
export const logoutOnSessionError = (message?: string): boolean => {
    if (!message) {
        return false;
    }
    if (message.includes('session_displaced')) {
        logout(true, 'session_displaced');
        return true;
    }
    if (message.includes(WHITE_LABEL_LOGIN_REQUIRED)) {
        logout(true, 'white_label_login_required');
        return true;
    }
    if (message.includes('Access denied') || message.includes('jwt expired')) {
        logout(true);
        return true;
    }
    return false;
};
